module.exports = __webpack_public_path__ + "static/media/mobile-product-bg-3.cf052697.svg";